module.exports = __webpack_public_path__ + "static/media/footer_logo.b7b9ab60.png";